module.exports = __webpack_public_path__ + "img/scadnow2.2a9617e9.jpg";